"use strict";

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSubscribe = exports.Subscribe = void 0;

var _react = require("react");

var Subscribe = function Subscribe(_ref) {
  var source = _ref.source,
      update = _ref.update;
  (0, _react.useEffect)(function () {
    var sub = (source instanceof Function ? source() : source).subscribe(update);
    return function () {
      return sub.unsubscribe();
    };
  }, [source]);
  return null;
};

exports.Subscribe = Subscribe;

var useSubscribe = function useSubscribe(source, init) {
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var _ref2 = (0, _react.useState)(init),
      _ref3 = _slicedToArray(_ref2, 2),
      snapshot = _ref3[0],
      setSnapshot = _ref3[1];

  (0, _react.useEffect)(function () {
    var subcription = (source instanceof Function ? source() : source).subscribe(setSnapshot);
    return function () {
      return subcription.unsubscribe();
    };
  }, deps);
  (0, _react.useDebugValue)(snapshot, JSON.stringify);
  return snapshot;
};

exports.useSubscribe = useSubscribe;